import { Link, NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Package, FolderTree, ShoppingBag, Users, Image, Settings, LayoutDashboard, LogOut } from "lucide-react";

const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_0dbeb9ed-131c-4cd1-83ca-d7c4e02f284b/artifacts/rg17olpw_WhatsApp%20Image%202026-10-01%20at%2011.40.01.jpeg";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/produtos", icon: Package, label: "Produtos" },
  { to: "/admin/categorias", icon: FolderTree, label: "Categorias" },
  { to: "/admin/pedidos", icon: ShoppingBag, label: "Pedidos" },
  { to: "/admin/clientes", icon: Users, label: "Clientes" },
  { to: "/admin/banners", icon: Image, label: "Banners" },
  { to: "/admin/configuracoes", icon: Settings, label: "Configurações" },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const nav = useNavigate();

  if (!ready) return <div className="min-h-screen bg-[#050505] text-zinc-400 grid place-items-center">Carregando...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#050505] text-white flex">
      <aside className="w-64 border-r border-white/10 bg-[#0A0A0C] p-5 shrink-0 hidden lg:flex flex-col">
        <Link to="/admin" className="flex items-center gap-3 mb-10">
          <img src={LOGO} alt="ActiveMode" className="h-10 w-10 object-contain" />
          <div>
            <div className="font-display text-sm tracking-tight">ACTIVEMODE</div>
            <div className="overline-label mt-1">Admin</div>
          </div>
        </Link>
        <nav className="flex-1 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 text-sm px-3 py-2.5 border-l-2 transition-colors ${isActive ? "border-white bg-white/5 text-white" : "border-transparent text-zinc-400 hover:text-white hover:border-white/30"}`}
            >
              <n.icon size={16} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="pt-6 border-t border-white/10 mt-4">
          <div className="text-xs text-zinc-500 px-3">{user.email}</div>
          <button onClick={() => { logout(); nav("/admin/login"); }} className="mt-3 flex items-center gap-2 text-xs text-zinc-400 hover:text-white px-3" data-testid="admin-logout">
            <LogOut size={14} /> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <header className="lg:hidden border-b border-white/10 bg-[#0A0A0C] px-5 py-4 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-2">
            <img src={LOGO} alt="" className="h-8 w-8 object-contain" />
            <span className="font-display tracking-tight">ADMIN</span>
          </Link>
          <button onClick={() => { logout(); nav("/admin/login"); }} className="text-xs text-zinc-400"><LogOut size={14} /></button>
        </header>
        <nav className="lg:hidden flex overflow-x-auto border-b border-white/10 bg-[#0A0A0C]">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `text-xs px-4 py-3 whitespace-nowrap border-b-2 ${isActive ? "border-white text-white" : "border-transparent text-zinc-500"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-5 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
